import React, { Component } from 'react'
import { CallBreakSelectTheme } from 'modules/theme'
import { globalStateSelector } from 'store/selector';
import { messageAction, globalAction } from 'store/action';
import { connect } from 'react-redux';

export class CallBreakSelect extends Component {
  constructor(props) {
    super(props);
    this.allowMedia = this.allowMedia.bind(this);
    this.getMediaPermission = this.getMediaPermission.bind(this);
    this.buttonLoadingTimer = this.buttonLoadingTimer.bind(this);
    this.timeout = "";
    this.buttonTimeout = "";
    this.callTimer = "";
    this.timer = 0;
    this.state = {
      "callTimer": 0,
      "loading":false,
      "timerText":""
    }
  }
  async allowMedia() {
    const { dynamicUpdate,registerUser,sipConfig  } = this.props;
    try {
      navigator.mediaDevices.getUserMedia( { audio: true, video: false } )
      .then( ( stream ) => {
              // microphone available
        console.log("Allowed", stream)
        stream.getTracks().forEach(function(track) {
          track.stop();
        });
        dynamicUpdate({ key: 'microPhoneState', value: "registered" });
        this.buttonLoadingTimer();
        registerUser("sip",{sipConfig,forceOnline : true})
      }, e => {
        console.log(" microphone not available", e)
        dynamicUpdate({ key: 'microPhoneState', value: "denied" });
        clearTimeout(global.__btnTimer);
      } );
    } catch (error) {
      console.log("microphone not available error", error);
      dynamicUpdate({ key: 'microPhoneState', value: "error" });
      clearTimeout(global.__btnTimer);
    }
  }
  async getMediaPermission() {
    const { dynamicUpdate, registerUser, sipConfig } = this.props;
    try{
      let microPhone = await navigator.permissions.query({ name: 'microphone' })
      console.log("microPhone",microPhone)
      if( microPhone && microPhone.state ){
        if( microPhone.state  == "denied"){
          dynamicUpdate({ key: 'microPhoneState', value: "denied" });
          clearTimeout(global.__btnTimer);
        } else if( microPhone.state  == "granted"){
          dynamicUpdate({ key: 'microPhoneState', value: "registered" });
          this.buttonLoadingTimer();
          registerUser("sip",{sipConfig,forceOnline : true})
        } else if( microPhone.state  == "prompt"){
          dynamicUpdate({ key: 'microPhoneState', value: "prompt" });
          clearTimeout(global.__btnTimer);
          this.allowMedia();
        }
      } else {
        this.allowMedia();
      }
    } catch (ex){
      console.log("Error in microphone");
      dynamicUpdate({ key: 'microPhoneState', value: "prompt" });
      this.allowMedia();
    }
  }
  userOnline() {
    const {  currentUser, dynamicUpdate } = this.props
    this.buttonLoadingTimer();
    if( currentUser.phoneType == "pstn" || currentUser.phoneType == "mobileEndPoint" ) {
      let message = {
        type: 'stateHandler',
        state: 'online',
        subState: '',
        stateInfo: ''
      };
      dynamicUpdate({ key: 'microPhoneState', value: "" });
      this.sendMessage(message)
    } else {
      console.log("Register Web");
      dynamicUpdate({ key: 'microPhoneState', value: "loading" });
      try {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(()=>{
          this.getMediaPermission();
        },1000)
      } catch (error) {
        console.log("Get Permission error",error )
        dynamicUpdate({ key: 'microPhoneState', value: "error" });
      }
    }
  }
  buttonLoadingTimer() {
    const { dynamicUpdate, microPhoneState } = this.props
    this.setState({"loading":true});
    try {
      clearTimeout(global.__btnTimer);
      this.timer = 35
      dynamicUpdate({ key: 'timerText', value: "" });
      global.__btnTimer = setInterval(()=>{
        this.timer--;  
        if( this.timer <= 0 ){
          this.setState({"loading":false});
          dynamicUpdate({ key: 'microPhoneState', value: "" });
          clearTimeout(global.__btnTimer);
        } else if( this.timer < 30 ){
          dynamicUpdate({ key: 'timerText', value: `Retry in ${this.timer} seconds` });
        }
        console.log("microPhoneState", microPhoneState, this.timer);
      },1000)
    } catch (error) {
      console.log("Get Permission error",error )
    }
  }
  sendMessage(message) {
    const { emitSocketMessage } = this.props;
    emitSocketMessage('message-processor', message);
  }
  render() {
    const { breakName, changeTab } = this.props
    return (
      <CallBreakSelectTheme 
        breakImg={'/images/Break.png'}
        breakName={ breakName || ""}
        breakText={'Break time taken'}
        breakTime={''}
        ButtonText={'Go Online'}
        OnClickEvent={() => {
          changeTab("offlineLoading")
          this.userOnline()
        }}
      />
    )
  }
}

const stateToProps = state => ({
  currentUser: globalStateSelector.getDynamic(state, { key: 'currentUser' }),
  breakName: globalStateSelector.getDynamic(state, { key: 'breakName' }),
  microPhoneState: globalStateSelector.getDynamic(state, { key: 'microPhoneState' }),
  timerText: globalStateSelector.getDynamic(state, { key: 'timerText' }),
  sipConfig: globalStateSelector.getDynamic(state, { key: 'sipConfig' }),
});

const dispatchToProps = dispatch => ({
  emitSocketMessage: (type, messageData) => {
    dispatch(messageAction.emitSocketMessage(type, messageData));
  },
  changeTab: tName => {
    dispatch(globalAction.tabState({ data: tName }));
  },
  dynamicUpdate: data => {
    dispatch(globalAction.dynamicUpdate({ data }));
  },
  registerUser: (type, messageData) => {
    dispatch(messageAction.registerUser(type, messageData));
  },
  changeTab: tName => {
    dispatch(globalAction.tabState({ data: tName }));
  }
});
export default connect(stateToProps, dispatchToProps)(CallBreakSelect);


// WEBPACK FOOTER //
// src/dialpad/components/layout/CallBreakSelect.js